import { Card } from "react-bootstrap";
import { CommonButton } from "../../Input";

const Step1WithdrawalAmount = ({
  withdrawalAmount,
  setWithdrawalAmount,
  customer,
}) => {
  const fee = 6.55;
  const total = parseFloat(withdrawalAmount || 0) + fee;

  return (
    <div className="mt-4">
      {/* Current Balance Card */}
      <Card>
        <Card.Body className="p-4 d-flex justify-content-between align-items-center">
          <div>
            <div className="text-muted fs-12 mb-1">Current balance</div>
            <div className="fw-bold text-black fs-20">111,612.45 SGD</div>
          </div>
          <CommonButton onClick={() => setWithdrawalAmount(111612.45)}>
            Withdraw All
          </CommonButton>
        </Card.Body>
      </Card>

      {/* Input Field */}
      <div className="mb-4">
        <label className="text-muted fs-12 mb-2 d-block">
          Withdrawal Amount *
        </label>
        <div className="input-group">
          <span
            className="input-group-text bg-white border-end-0 text-muted fs-13"
            style={{ borderRadius: "8px 0 0 8px" }}
          >
            SGD
          </span>
          <input
            type="number"
            className="form-control border-start-0 fs-14 py-2"
            style={{ borderRadius: "0 8px 8px 0", height: "45px" }}
            value={withdrawalAmount || ""}
            onChange={(e) => setWithdrawalAmount(e.target.value)}
            placeholder="0.00"
          />
        </div>
      </div>

      {/* Summary Box */}
      <div
        className="rounded-4 p-4"
        style={{ backgroundColor: "#F8Faff", border: "1px solid #E2E8F0" }}
      >
        <div className="d-flex justify-content-between mb-3">
          <span className="text-muted fs-13">Withdrawal Amount</span>
          <span className="fw-bold text-black fs-14">
            {parseFloat(withdrawalAmount || 0).toFixed(2)} SGD
          </span>
        </div>
        <div className="d-flex justify-content-between mb-3 pb-3 border-bottom">
          <span className="text-muted fs-13">Fee</span>
          <span className="fw-bold text-black fs-14">{fee.toFixed(2)} SGD</span>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="fw-bold text-black fs-16">Total</div>
          <div className="text-end">
            <div className="fw-bold fs-18" style={{ color: "#002147" }}>
              SGD {total.toFixed(2)} SGD
            </div>
            <div className="text-muted fs-11 mt-1">
              This total amount will be deducted from wallet
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step1WithdrawalAmount;
